import { render } from "./swipe.vue?vue&type=template&id=50f6aca4&scoped=true"
import script from "./swipe.vue?vue&type=script&lang=js"
export * from "./swipe.vue?vue&type=script&lang=js"

import "./swipe.vue?vue&type=style&index=0&id=50f6aca4&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f6aca4"]])

export default __exports__